export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6124.f14ad3a9.jpg";